var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18616_86372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87046 0.787584C8.70987 0.454286 8.37051 0.242188 7.99782 0.242188C7.62514 0.242188 7.28881 0.454286 7.12519 0.787584L5.17691 4.79625L0.825864 5.4386C0.462267 5.49314 0.159269 5.74766 0.04716 6.09611C-0.0649493 6.44455 0.02595 6.82936 0.286528 7.08691L3.44377 10.2108L2.69839 14.6255C2.63779 14.9891 2.78929 15.3588 3.08926 15.5739C3.38923 15.789 3.78615 15.8163 4.11339 15.6436L8.00085 13.568L11.8883 15.6436C12.2156 15.8163 12.6125 15.792 12.9124 15.5739C13.2124 15.3557 13.3639 14.9891 13.3033 14.6255L12.5549 10.2108L15.7121 7.08691C15.9727 6.82936 16.0667 6.44455 15.9515 6.09611C15.8364 5.74766 15.5364 5.49314 15.1728 5.4386L10.8187 4.79625L8.87046 0.787584Z",
    fill: "#EDAC1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18616_86372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.77bf33b71ebfd049d15e4a2224f137cf.svg";
export { ForwardRef as ReactComponent };